export default __webpack_public_path__ + "static/media/authy.97108270.svg";